import React from 'react'
import { cn } from '@/utilities/ui'

import type { EmbedMeta, EmbedPostProps } from './types'
import { embedMappings } from './embedMappings'

export type { EmbedPostProps } from './types'

const defaultMeta: EmbedMeta = {
    buildSource: () => ({
        srcDoc: `<html></html>`, // Default to a blank document
    }),
    iframeProps: {},
}

export const EmbedPostBlock: React.FC<EmbedPostProps> = (props) => {
    const { postId, type, className } = props
    const { buildSource, iframeProps } = embedMappings[type] || defaultMeta
    const source = buildSource(props)
    return (
        <iframe
            {...iframeProps}
            data-src={`https://qz.com/embed/inset/iframe?id=${type}-${postId}&autosize=1`}
            srcDoc={source.srcDoc.trim().replaceAll(/\s+/g, ' ')}
            id={`${type}-${postId}`}
            data-recommended='false'
            className={cn('w-full fit-content rounded-2xl p-4 bg-gray-200 my-2', iframeProps.className, className)}
            sandbox='allow-scripts allow-same-origin'
            frameBorder='0'
            scrolling='no'
            loading='lazy'
            allowFullScreen
        ></iframe>
    )
}
